<template>
    <layout>
        <template v-slot:title>{{ $t('Last images for each camera') }}</template>
        <template v-slot:subtitle>{{
            $t(
                'This page provides the latest images from all cameras of the SOCIB coastal video monitoring system installed along the Balearic Islands coast.'
            )
        }}</template>
        <center>
            <div class="last_images">
                <div v-for="(location, index) in locations" :key="index + '_location'">
                    <md-content class="md-elevation-24" style="margin: 10px">
                        <LastImage
                            :station="location.location_code"
                            :groups="getGroupsString(index)"
                            :title="location.location_name"
                        />
                    </md-content>
                </div>
            </div>
        </center>
    </layout>
</template>

<script>
// @ is an alias to /src
import Layout from '@components/layout'
import LastImage from '@components/lastImage'
export default {
    props: {},
    computed: {
        locations() {
            return this.$store.state.locations
        }
    },
    watch: {},
    name: 'Home',
    components: {
        Layout,
        LastImage
    },
    methods: {
        getGroupsString(id) {
            var groups = ''
            for (var index in this.locations[id].camera_groups) {
                groups = groups + this.locations[id].camera_groups[index].code + ','
            }
            return groups.slice(0, -1)
        }
    }
}
</script>
